import { render } from "./CabinetHeader.vue?vue&type=template&id=1d5075e6&lang=pug"
import script from "./CabinetHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__